import { render, staticRenderFns } from "./RateVersionManager.vue?vue&type=template&id=98f1e848&scoped=true"
import script from "./RateVersionManager.vue?vue&type=script&lang=js"
export * from "./RateVersionManager.vue?vue&type=script&lang=js"
import style0 from "./RateVersionManager.vue?vue&type=style&index=0&id=98f1e848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f1e848",
  null
  
)

export default component.exports